import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import { QuestionStore } from '../state/question.store';

declare const $: any;

@Component({
    selector: 'app-question-label-amount',
    templateUrl: './question-label-amount.component.html',
    styleUrls: ['./question-label-amount.component.scss'],
    standalone: false
})
export class QuestionLabelAmountComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() showToolTip = false;
  @Input() showDelete = false;
  @Input() isEditModal = false;
  @Output() questionAnswer = new EventEmitter<any>();

  maskOptions: NgxCurrencyConfig;
  value = '';
  uniqueControlName = `label-amount-${newGuid()}`;
  uniqueId = `label-amount-${newGuid()}`;
  parameters: any;
  placeholder = '';
  currency: any;
  readonly = false;
  itk: any;
  constructor(private questionService: GlobalQuestionService,private questionStore: QuestionStore,) { }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.questionService.initPopoverCustomize();
    }, 500);
    if (this.question?.parameter) {
      this.parameters = JSON.parse(this.question?.parameter);

      if (this.parameters?.length) {
        if (this.parameters.find(x => x?.parameter === 'currency') ){
          this.currency = this.parameters.find(x => x?.parameter === 'currency')?.value;
          this.maskOptions = {
            max: null,
            min: 0,
            allowZero: true,
            nullable: false,
            inputMode: NgxCurrencyInputMode.Natural,
            align: 'left',
            allowNegative: false,
            //prefix: this.parameters[0]?.value+' ',
            prefix: '',
            decimal: '.',
            suffix: '',
            thousands: ' ',
            precision: 0
          };
        } else {
          this.placeholder = '0';
          this.maskOptions = {
            max: null,
            min: 0,
            allowZero: true,
            nullable: false,
            align: 'right',
            allowNegative: false,
            prefix: '',
            decimal: '.',
            suffix: '',
            thousands: ' ',
            precision: 0
          };
        }

        if ( this.parameters?.find(x => x?.parameter.toLowerCase() === 'readonly') ){
          this.readonly = true;
        }
      }
    }
    else {
      this.placeholder = '0';
      this.maskOptions = {
        max: null,
        min: 0,
        allowZero: true,
        nullable: false,
        align: 'left',
        allowNegative: false,
        prefix: '',
        decimal: '.',
        suffix: '',
        thousands: ' ',
        precision: 0
      };
      //this.value = '0';
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.value = '';
    
     if (changes?.question?.currentValue) {
       this.question = changes?.question?.currentValue;
      
       if (this.question?.answer) {
         this.value = this.question?.answer;
         
      } else {
        if (this.question) {
          this.question.answer = '0';
          this.questionAnswer.emit(this.question);
        }
       }
     }
    
    
    if (changes?.showToolTip?.currentValue) {
      this.showToolTip = changes?.showToolTip?.currentValue;
    }
    if (changes?.showDelete?.currentValue) {
      this.showDelete = changes?.showDelete?.currentValue;
    }
    if (this.question?.itk) {
      this.itk = JSON.parse(this.question?.itk)[0];
      
    }
    
  }

  onChange(): void {
    // In the edit modal each emit triggers an individual save, a premium recalc and the
    // checkPolicyChanges call, so we commit on blur (onCommit) instead of per keystroke.
    // In the linear flow we keep emitting live on every change.
    if (this.isEditModal) {
      return;
    }
    this.emitAnswer();
  }

  onCommit(): void {
    if (!this.isEditModal) {
      return;
    }
    this.emitAnswer();
  }

  private emitAnswer(): void {
    if (+this.value >= 0) {
      if (this.question) {
        this.question.answer = this.value.toString();
        //this.questionStore.update(this.question.cent_aq_question_id,{answer: this.value.toString()});
        this.questionAnswer.emit(this.question);
      } else {
        this.questionAnswer.emit(this.value.toString());
      }
    }
  }

  saveAnswer(question: Question): void {
    this.questionService.saveAnswerOnly(question).subscribe();
  }

}
